module.exports = __webpack_public_path__ + "media/images/landing/icons/yandex_zen-eeea5df82216e0d13ebaf0378cc71976.svg";